import React from 'react';
import './Spinner.css';

const Spinner = () => (
<div className="loader">Click To Load More</div>
)

export default Spinner;